import { cx } from '../cx.js';

export interface LiveBadgeProps {
  testo?: string;
  className?: string;
}

/** Pillola "IN DIRETTA": l'unico richiamo diretto al marchio dentro l'app. */
export function LiveBadge({ testo = 'IN DIRETTA', className }: LiveBadgeProps) {
  return (
    <span className={cx('inline-flex items-center gap-2 rounded-full bg-accent-soft text-accent px-3 py-1 t-caption', className)}>
      <span aria-hidden className="punto-live inline-block h-2 w-2 rounded-full bg-live" />
      {testo}
    </span>
  );
}
